import { makeRequest } from "../helpers/api.helpers";
import { createDebounce } from "../helpers/debounce.helper";
import { getCompanyId } from "./company.api";

const API_URL = import.meta.env.VITE_API_URL;

const makeRequestDebounced = createDebounce(makeRequest, 200);

export async function createMaintenanceCharge(maintenanceData) {
  const data = {
    ...maintenanceData,
    companyId: getCompanyId(),
  };
  const url = `${API_URL}/maintenance-charge`;
  const options = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  };
  return makeRequestDebounced(url, options);
}